import { Tooltip } from '@ibsys/kit';
import { FC } from 'react';
import type { RunTaskDetail } from '@/entities/jobs';
import { TaskCircleIcon } from './TaskCircleIcon';
import { CIRCLE_CLASS, TASK_CIRCLE_STYLES } from './utils';

type TaskCircleProps = {
  task: RunTaskDetail;
  onClick?: (task: RunTaskDetail) => void;
};

// Кружок статуса отдельной задачи
export const TaskCircle: FC<TaskCircleProps> = ({ task, onClick }) => {
  const styles = TASK_CIRCLE_STYLES[task.status] ?? TASK_CIRCLE_STYLES.PENDING;
  const isRunning = task.status === 'RUNNING';

  return (
    <Tooltip tooltip={task.taskId}>
      <div
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? -1 : undefined}
        className={`${CIRCLE_CLASS} ${styles.bg} ${styles.border} ${styles.icon} ${isRunning ? 'animate-pulse' : ''} ${onClick ? 'cursor-pointer hover:ring-2 hover:ring-ring' : ''}`}
        onClick={
          onClick
            ? (e: React.MouseEvent) => {
                e.stopPropagation();
                onClick(task);
              }
            : undefined
        }
      >
        <TaskCircleIcon status={task.status} />
      </div>
    </Tooltip>
  );
};
